import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import ReactJson from 'react-json-view';
import { getPaymentBillLogInfo, getPaymentInfoSelector } from 'store/payment';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import s from './index.module.scss';

export const PaymentLogsPage: FC = () => {
	const dispatch = useAppDispatch();
	const { paymentId } = useParams();

	const paymentLogs = useAppSelector(getPaymentInfoSelector);
	const [isCopied, setIsCopied] = useState(false);

	useEffect(() => {
		if (paymentId) {
			dispatch(getPaymentBillLogInfo(paymentId));
		}
	}, [dispatch, paymentId]);

	const handleCopy = async () => {
		if (!paymentLogs) return;

		try {
			await navigator.clipboard.writeText(JSON.stringify(paymentLogs, null, 2));
			setIsCopied(true);
			window.setTimeout(() => setIsCopied(false), 1200);
		} catch {
			setIsCopied(false);
		}
	};

	return (
		<Box className={s.wrapper}>
			<Box className={s.header}>
				<Box className={s.headerTop}>
					<Typography variant="h6">Логи платежу</Typography>
					<Button size="small" variant="contained" onClick={handleCopy} disabled={!paymentLogs}>
						{isCopied ? 'Скопійовано' : 'Copy JSON'}
					</Button>
				</Box>

				{paymentId && (
					<Typography variant="body2" className={s.paymentId}>
						{paymentId}
					</Typography>
				)}
			</Box>

			<Box className={s.logsBox}>
				{paymentLogs ? (
					<ReactJson
						src={paymentLogs}
						name={false}
						collapsed={false}
						displayDataTypes={false}
						displayObjectSize={false}
						enableClipboard
						iconStyle="square"
						theme="rjv-default"
					/>
				) : (
					<Typography variant="body2">Немає даних логів</Typography>
				)}
			</Box>
		</Box>
	);
};
